import { render, staticRenderFns } from "./GroupDetailsBase.vue?vue&type=template&id=34c97dd3"
import script from "./GroupDetailsBase.vue?vue&type=script&lang=ts"
export * from "./GroupDetailsBase.vue?vue&type=script&lang=ts"
import style0 from "./GroupDetailsBase.vue?vue&type=style&index=0&id=34c97dd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports